import { getWhiteLabelId } from "shared/api";
import { WhiteLabelParams } from "../types";

/**
 * Поля бренда для запросов v3. Для AKJET — пустой объект:
 * пустые поля и null сервер передавать запрещает.
 */
export const getWhiteLabelParams = (): WhiteLabelParams => {
  const id = getWhiteLabelId();
  return id === undefined ? {} : { white_label_id: id };
};
